import * as React from 'react';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    id?: string;
    isImportant?: boolean
}

export function SetHtmlOverflow(isOverflow: boolean) {
    if (isOverflow)
        document.getElementsByTagName("html")[0].classList.add("no-overflow");
    else
        document.getElementsByTagName("html")[0].classList.remove("no-overflow");
}

export class Modal extends React.PureComponent<ModalProps> {

    public render() {
        return (
            <div className={`modal__wraper ${this.props.isOpen && "isOpen"} ${this.props.isImportant && "isImportant"}`} id={this.props.id || ""} onMouseDown={() => { SetHtmlOverflow(false); this.props.onClose() }}>
                <div className='modal__padding' onMouseDown={() => { SetHtmlOverflow(false); this.props.onClose() }} />
                <div className='modal__content' onMouseDown={(e) => e.stopPropagation()}>{this.props.children}</div>
                <div className='modal__padding' onMouseDown={() => { SetHtmlOverflow(false); this.props.onClose() }} />
            </div>
        );
    }
}

export class Popup extends React.PureComponent<ModalProps> {

    public render() {
        return (
            <div className={`popup__wraper ${this.props.isOpen && "isOpen"}`} onMouseDown={() => { SetHtmlOverflow(false); this.props.onClose() }}>
                <div className='popup__padding' onMouseDown={() => { SetHtmlOverflow(false); this.props.onClose() }} />
                <div className='popup__content' onMouseDown={(e) => e.stopPropagation()}>{this.props.children}</div>
                <div className='popup__padding' onMouseDown={() => { SetHtmlOverflow(false); this.props.onClose() }} />
            </div>
        );
    }
}